import React from "react";
import { Box, SpaceBetween } from "@cloudscape-design/components";

const FinanceSalariesHelp = () => (
  <SpaceBetween size="m">
    <Box>
      <strong>Purpose</strong>
      <p>Record annual salary commitments for each province, territory and NWAC National, assigned to the relevant fiscal year’s budget pot.</p>
    </Box>
    <Box>
      <strong>How to use it</strong>
      <p>Select a fiscal year, review the row for each region, assign the correct pot, enter the annual total, and save your changes. The saved annual total appears as Committed in Budgets. Budget Overview spreads it evenly across twelve months.</p>
    </Box>
    <Box>
      <strong>Scope</strong>
      <p>This dashboard supports oversight and reporting preparation. It is not the payroll or accounting system of record.</p>
    </Box>
  </SpaceBetween>
);

FinanceSalariesHelp.aiContext =
  "Guide authorized PATH administrators using the Salaries dashboard. Keep the language user-facing: annual salary commitments by province, territory and NWAC National, explicit budget-pot assignment within the selected fiscal year, even monthly amounts, save and refresh workflow, and the fact that PATH is tracking/reporting support rather than the payroll system of record. Annual commitments feed Budgets and Budget Overview but do not imply payroll paid; Financial Reports remains client funding only.";

export default FinanceSalariesHelp;
